import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ButtonView } from 'ckeditor5/src/ui';
import icon from './insert_citation.svg';

export class SBReferencesPlugin extends Plugin {

    static get pluginName() {
        return 'SBReferences';
    }

    init() {
        const editor = this.editor;
        this.bind('openReferencesLinkModal').to(editor, 'sbOpenReferencesLinkModal');

        editor.ui.componentFactory.add( 'sbReference', locale => {
            const linkCommand = editor.commands.get( 'link' );
            const view = new ButtonView( locale );

            view.set( {
                label: editor.t( 'Insert Reference' ),
                icon: icon,
                tooltip: true
            } );

            view.bind( 'isEnabled' ).to( linkCommand, 'isEnabled' );

            // Execute the command.
            this.listenTo( view, 'execute', () => {
                this.openReferencesLinkModal();
            } );

            return view;
        } );
    }
}
